import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';
import FormItemUtil from '../utils/FormItemUtil';
import LookupActions from '../actions/LookupActions';
import {UpdateInnerToolBarStore} from '../stores/UtilStores';
import DomActions from '../actions/DomActions';

require('../styles/FormDesign.css');

class FormItemDesign extends FormItemContainer
{

	getProperty_Layout()
	{
		let properties = this.props.xml.firstChild;
		let elements = properties.getElementsByTagName("Property");
		let result;
		for (var i = 0; i < elements.length; i++) 
		{
	        var name = elements[i].getElementsByTagName("Name")[0].firstChild.nodeValue;
	        if(name == "Layout")
	        {
	        	var value = elements[i].getElementsByTagName("Value")[0].firstChild.nodeValue;
	        	result = value;
	        	break;
	        }
		}
		return result;
	}

	constructor(props)
	{
		super(props);
		let _parentWindow = window.parent.window;
		if(_parentWindow && _parentWindow.userSettingEntry && _parentWindow.userSettingEntry.innerToolBar)
			this.unsubcribeUpdateInnerToolBarStore = UpdateInnerToolBarStore.listen(this.updateInnerToolBarStore.bind(this));
	}

	updateInnerToolBarStore(obj)
	{
		
		obj.Export==true?$(this.toolbarExport).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarExport).removeAttr("onclick").removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.Da==true?$(this.toolbarDa).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarDa).removeAttr("onclick").removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		if(obj.Attachment==true)
		{
		  $(this.toolbarAttchment).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"});$(this.attachmentNum).show();
		}
		else
		{
		  $(this.toolbarAttchment).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});$(this.attachmentNum).hide();
		}
	  
		obj.WorkFlowDetail==true?$(this.toolbarWorkflow).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarWorkflow).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.QueryOpen==true?$(this.toolbarQueryopen).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarQueryopen).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.QueryRemove==true?$(this.toolbarQueryRemove).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarQueryRemove).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.FindOpen==true?$(this.toolbarFind).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarFind).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.CursorPrev==true?$(this.toolbarRecordPrev).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarRecordPrev).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.CursorNext==true?$(this.toolbarRecordNext).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarRecordNext).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.RecordNew==true?$(this.toolbarRecordNew).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarRecordNew).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.RecordSave==true?$(this.toolbarSave).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarSave).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.EditModeChange==true?$(this.toolbarSwitchEditMode).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarSwitchEditMode).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.RecordRestore==true?$(this.toolbarRecordRestore).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarRecordRestore).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	  
		obj.RecordDelete==true?$(this.toolbarRecordDelete).attr("en","true").find("i").css({color:"#505050",pointerEvents:"auto"}):$(this.toolbarRecordDelete).removeAttr("en").find("i").css({color:"#c2c2c2",pointerEvents:"none"});
	}

	getStyle()
	{
		let layout = this.props.xml.Properties.Layout.Value;
		
		let flexDirection = (layout=="horizontal"?"row":"column");
		let style = {
	      //flex-direction:flexDirection,
	      //align-items:"flex-start",
	      display:"flex",
	      width:"100%",
	      height:"100%"
	    };
	    style["flexDirection"] = flexDirection;
	    style["alignItems"] = "flex-start";
	    //style["overflow"] = 'auto';
	    /*if(this.props.isLookup)
	    {
	    	style["position"] = 'absolute';style["top"] = "34px";style["left"] = "200px";
	    }*/
		return style;
	}

	closePopUpFormHandler()
	{
		window.parent.window.dataSetPreview = null;
		if(this.props.isPop)
		{
			LookupActions.popDropDownClose(this.props.stringEditorEntityId,this.props.stringEditorInnerId);
		}
		else
		{
			var _parentWindow = window.parent.window;
	      	if(_parentWindow)
	      	{
	      		_parentWindow.closePopUpForm(window.menuItemId,window.formId,true);
	      	}	
		}
	}	

	getDisplayLength()
	{

	}

	innerToolBarExport()
	{
		window.groupExport();
	}

	innerToolBarDataAn()
	{
		window.da();
	}

	innerToolBarAttachment()
	{
		window.attachment();
	}

	innerToolBarWorkFlow()
	{
		window.workFlow();
	}

	innerToolBarQueryOpen()
	{
		window.queryOpen();
	}

	innerToolBarQueryRemove()
	{
		window.queryRemove();
	}

	innerToolBarFind()
	{
		window.find();
	}

	innerToolBarRecordPre()
	{
		window.recordPrev();
	}

	innerToolBarRecordNext()
	{
		window.recordNext();
	}

	innerToolBarRecordNew()
	{	
		window.recordNew();
	}

	innerToolBarRecordSave()
	{
		window.recordSave();
	}

	innerToolBarEditMode()
	{
		window.switchEditMode();
	}

	innerToolBarRecordRestore()
	{
		window.recordRestore();
	}

	innerToolBarDelete()
	{
		window.recordDelete();
	}

	innerToolBarGlobaluserSet()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.globalUserSetOpen();
	}

	innerToolBarReInitForm()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.reInitForm();
	}

	innerToolBarReInitGlobal()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.reInitGlobal();
	}

	innerToolBarImportManager()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.importManager();
	}

	innerToolBarJobsOpen()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.jobsOpen();
	}

	showOnLineUser()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow)
			_parentWindow.showOnLineUser();
	}
	//style={{display:'none',position:'absolute',right:0,left:'auto',width:'200px',padding:'0 0 0 0',margin:0,top:'100%',borderTopLeftRadius:0,borderTopRightRadius:0,boxShadow:'none',borderColor:'#eee'}}
	getToolBarInner()
	{
		let _parentWindow = window.parent.window;
		if(_parentWindow.userSettingEntry && !_parentWindow.userSettingEntry.innerToolBar)
			return null;
		let isAdmin;
		if (_parentWindow.userInfos.isAdmin == true)
			isAdmin = true;
		else
			isAdmin = false;
		let expandNodeDisplay = isAdmin?'block':'none';
		return <ul style={{display:'flex',flexDirection:'row',alignItems:'flex-end',margin:'0px',padding:'0px'}} className="innerToolBar">

			<li className="dropdown messages-menu" title="导出(Ctrl+O)">
				<a onClick={this.innerToolBarExport.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer"}} ref={node=>this.toolbarExport = node}>
					<button style={{width:"45px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px",paddingTop:"2px"}}>
						<i className="fa fa-share-square-o" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="数据分析(Ctrl+I)">
				<a onClick={this.innerToolBarDataAn.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" 	style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer"}} ref={node=>this.toolbarDa = node}>
					<button style={{width:"45px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px"}}>
						<i className="fa fa-bar-chart" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>
		
			<li className="dropdown messages-menu" title="附件">
				<a onClick={this.innerToolBarAttachment.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor: "pointer"}}  ref={node=>this.toolbarAttchment = node}>
					<span id="attachmentNum" ref={node=>this.attachmentNum = node} className="label label-danger" style={{display:"none",position:'absolute',top:'-2px',right:'7px',textAlign:'center',fontSize:'9px',padding:'2px 3px',lineHeight:'.9'}}>0</span>
					<button style={{width: "30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px"}}>
						<i className="fa fa-paperclip" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li class="dropdown messages-menu" title="工作流" style={{display:"none"}}>
        		<a onClick={this.innerToolBarWorkFlow.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer"}} ref={node=>this.toolbarWorkflow = node}>
					<button style={{width:"45px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px"}}>
						<i className="fa fa-random" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="打开筛选(Ctrl+Q)">
       		    <a onClick={this.innerToolBarQueryOpen.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingRight:"0px !important"}}  ref={node=>this.toolbarQueryopen = node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopLeftRadius:"2px",borderBottomLeftRadius:"2px"}}>
						<i className="fa fa-filter" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="移除筛选(Ctrl+E)">
        	    <a onClick={this.innerToolBarQueryRemove.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingLeft:"0px !important"}}  ref={node=>this.toolbarQueryRemove = node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopRightRadius:"2px",borderBottomRightRadius:"2px",borderLeft:"0.5px solid rgb(201, 200, 201)"}}>
						<i className="fa fa-filter fa-flip-horizontal" style={{color:"#474747"}}></i>
						<i className="fa fa-minus" aria-hidden="true" style={{color:"#474747",position:"absolute",top:"12px",right:"10px",textAlign:"center",fontSize:"9px",padding:"2px 3px",lineHeight:".9"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="查找(Ctrl+F)">
				<a onClick={this.innerToolBarFind.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer"}} ref={node=>this.toolbarFind = node}>
					<button style={{width:"45px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px"}}>
						<i className="fa fa-search" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="上一条">
        		<a onClick={this.innerToolBarRecordPre.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingRight:"0px !important"}} ref={node=>this.toolbarRecordPrev = node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopLeftRadius:"2px",borderBottomLeftRadius:"2px"}}>
						<i className="fa fa-play fa-flip-horizontal" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="下一条">
        		<a onClick={this.innerToolBarRecordNext.bind(this)}  className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingLeft:"0px !important"}} ref={node=>this.toolbarRecordNext = node}>
          			<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopRightRadius:"2px",borderBottomRightRadius:"2px",borderLeft:"0.5px solid rgb(201, 200, 201)"}}>
            			<i className="fa fa-play" style={{color:"#474747"}}></i>
          			</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="新增(Ctrl+~)">
        		<a className="dropdown-toggle toolbarA" data-toggle="dropdown" onClick={this.innerToolBarRecordNew.bind(this)} style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingRight:"0px !important"}} ref={node => this.toolbarRecordNew=node}>
          			<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopLeftRadius:"2px",borderBottomLeftRadius:"2px"}}>
            			<i className="fa fa-plus-square"style={{color:"#474747"}}></i>
          			</button>
				</a>
      		</li>


			<li className="dropdown messages-menu" title="保存(Ctrl+S)">
        		<a onClick={this.innerToolBarRecordSave.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingLeft:"0px !important"}} ref={node=>this.toolbarSave = node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderLeft:"0.5px solid rgb(201, 200, 201)"}}>
						<i className="fa fa-save" style={{color:"#474747"}}></i>
					</button>
				</a>
      		</li>

			
			<li className="dropdown messages-menu" title="切换编辑模式">
				<a onClick={this.innerToolBarEditMode.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" ref={node=>this.toolbarSwitchEditMode = node} style={{userSelect:"none",cursor:"pointer"}}>
          			<button style={{width:"45px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderRadius:"2px"}}>
					  <i className="fa fa-pencil-square-o" style={{color:"#474747"}}></i>
					  <i className="fa fa-ban text-danger" style={{position:"absolute",top:"11px",right:"14px",textAlign:"center",fontSize:"9px",padding:"2px 3px",lineHeight:".9"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="恢复(Ctrl+R)">
        		<a onClick={this.innerToolBarRecordRestore.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingLeft:"0px"}} ref={node=>this.toolbarRecordRestore = node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)",borderTopRightRadius:"2px",borderBottomRightRadius:"2px"}}>
						<i className="fa fa-reply-all" style={{color:"#474747"}}></i>
					</button>
				</a>
			</li>

			<li className="dropdown messages-menu" title="删除(Ctrl+Delete)">
				<a onClick={this.innerToolBarDelete.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{color:"#c2c2c2",userSelect:"none",cursor:"pointer",paddingLeft:"0px",paddingRight:"0px"}} ref={node=>this.toolbarRecordDelete=node}>
					<button style={{width:"30px",height:"24px",backgroundImage:"linear-gradient(180deg,#FCFCFC 0%,#F3F3F3 100%)",border:"0.5px solid #C9C8C9",boxShadow:"0 1px 5px 0 rgba(0,0,0,0.08)"}}>
						<i className="fa fa-trash" style={{color:"#474747"}}></i>
					</button>
				</a>
      		</li>

			<div className="navbar-custom-menu" style={{display:'flex',flexDirection:'row',justifyContent:'flex-end',flexGrow:1}}>
				<ul className="nav navbar-nav">
					<li className="dropdown messages-menu" title="设置">
						<a href="#" onClick={this.innerToolBarGlobaluserSet.bind(this)} className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{padding:'4px',paddingRight:'10px',color:'#f6f6f6'}}>
							<i className="fa fa-cog" style={{color:"#505050",fontSize:"17px"}}></i>
						</a>
					</li>
					
					<li className="dropdown notifications-menu" style={{display:expandNodeDisplay}} ref={node=>this.expandNode=node}>
						<a href="#" className="dropdown-toggle toolbarA" data-toggle="dropdown" style={{padding:'15px',color:'#f6f6f6',backgrondColor:'unset !important'}}>
							<i className="fa fa-cubes"></i>
						</a>
						<ul className="dropdown-menu">
							<li className="header">可用扩展项</li>
							<li>
								<ul className="menu">
									<li>
										<a href="#" onClick={this.innerToolBarReInitForm.bind(this)}>
											<i className="fa fa-users text-aqua"></i>初始化画面
										</a>
									</li>
									<li>
										<a href="#" onClick={this.innerToolBarReInitGlobal.bind(this)}>
											<i className="fa fa-warning text-yellow"></i>初始化全局
										</a>
									</li>
									<li>
										<a href="#" onClick={this.innerToolBarImportManager.bind(this)}>
											<i className="fa fa-shopping-cart text-green"></i>导入控制台
										</a>
									</li>
									<li>
										<a href="#" onClick={this.innerToolBarJobsOpen.bind(this)}>
											<i className="fa fa-paper-plane text-red"></i>远程调用
										</a>
									</li>
									<li>
										//TODO 去掉 改成在menu里面
										{/* <a href="#" onClick={this.showOnLineUser.bind(this)}>
											<i className="fa fa-paper-plane text-red"></i>在线用户
										</a> */}
									</li>
								
								</ul>
							</li>
						</ul>
					</li>
				</ul>
			</div>
  		</ul>;
	}

	lookupOnKeyDown(e)
	{
		if(e.keyCode == 27 || (e.ctrlKey && e.keyCode == 38))
		{
			LookupActions.popDropDownClose(this.entityId,this.innerId);
		}
	}

	/*componentWillUnmount()
	{
		if(this.props.forLookup)
		{
			$(this.containerComponent).off("onkeydown");
		}
	}*/

	componentDidMount()
	{

		/*if(this.props.forLookup)
		{
			$(this.containerComponent).on("onkeydown",this.lookupOnKeyDown.bind(this));
		}*/

		if((window.isPopUp && !this.props.forLookup) || (this.props.isPop && this.props.forLookup))
		{

			let width = this.props.control.getProperty_Width();
			if(width)
			{
				if((width+"").indexOf("%") != -1)
				{
					$(this.outterDiv).css("width",width);
				}
				else
				{
					$(this.outterDiv).css("width",width+'px');
				}
			}
			else
			{
				let _parentDocument = window.parent.document;
				let maxWidth = $(".content-wrapper",_parentDocument).outerWidth(true);
				maxWidth -= 100;
				let nowWidth = $(this.outterDiv).outerWidth();
				if(nowWidth>maxWidth)
				{
					$(this.outterDiv).css("overflow","hidden").width(maxWidth);
					$(this.containerComponent).css("overflow","auto");
					$(".datagridcontainer").css("max-width","100%");
				}
				else
				{
					$(this.outterDiv).css("width",nowWidth+2+'px');
				}
			}

			let height = this.props.control.getProperty_Height();
			if(height)
			{
				if((height+"").indexOf("%") != -1)
				{
					$(this.outterDiv).css("height",height);
				}
				else
				{
					$(this.outterDiv).css("height",height+'px');
				}
			}
			else
			{
				let _parentDocument = window.parent.document;
				let maxHeight = $(".content-wrapper",_parentDocument).outerHeight(true);
				
				maxHeight -= 10;
				let nowHeight = $(this.outterDiv).outerHeight();
				if(nowHeight>maxHeight)
				{
				
						$(this.outterDiv).css("overflow","hidden").height(maxHeight);
						let headerHeight = $(this.modalHeader).outerHeight(true);
						$(this.containerComponent).css("overflow","auto").height(maxHeight-headerHeight-5);
						$(".datagridcontainer").css("max-height","100%");

					
				}
				else
				{
					$(this.outterDiv).css("height",nowHeight+4+'px');
				}
			}

			$(this.outterDiv).draggable({
				handle: ".modal-header" // 只能点击头部拖动
			});

			DomActions.popUpDomReady();
		}
	}

	getQueryString (name, url) {
		var arr = url.split("?");
		if (arr != null && arr.length > 1) {
		  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		  var r = arr[1].match(reg);
		  if (r != null) {
			return unescape(r[2]);
		  }
	  
		}
		return null;
	  }
	
	  getIsUniversalViewRep(){
		if(this.getQueryString("isPreview", window.location.search)){
		  return true;
		}
		return false;
	  }
	  universalViewReportBtn(){
		window.parent.window.toobarFunc(null,"groupExport","")
	  }
	  universalViewPivotBtn(){
		window.parent.window.toobarFunc(null,"da","")
	  }

	  universalViewDSExpBtn(){
		window.dataSetViewDSExp();
	  }

	  universalViewRSelectBtn(){
		window.dataSetViewRSelect();
	  }

	  universalViewPrintAppBtnOk(){
		window.universalViewPrintAppBtnOk();
		this.closePopUpFormHandler();
	  }
	
	//<i className="fa fa-close" style={{position:"absolute",top:"8px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closePopUpFormHandler.bind(this)}></i>
	render()
	{
		//this.props.formItem.getDisplayLength();
		let parent = this.props.xml;
		let children = parent.FormItem;
		let layout = parent.Properties.Layout.Value;
		let that = this;
		let splitterStyle = {alignSelf:'stretch',backgroundColor:'#ccc !important',opacity: 0,border:'none !important',flexShrink:'0'};
		if(layout == "vertical")splitterStyle.height = "4px";
		else splitterStyle.width = "4px";
		let list = [];
		for(let i = 0;i<children.length;i++)
		{
			let item = children[i];
			list.push(FormItemUtil.getFormItemInstance(that.props.menuItemId,that.props.formId,item,parent,that.props.forLookup));
			//if(i<children.length-1)
			//	list.push(<div className={"GongqiFormFirstSplitter"} style={splitterStyle}></div>);
		}
		/*let list = children.map(function(item){
			return 
  		 });*/
		/*<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closePopUpFormHandler.bind(this)}>
          <span aria-hidden="true" style={{fontSize:"20px"}}>×</span>
		</button>*/
		let innerToolBar = this.getToolBarInner();
		let _style = Object.assign({},this.props.customStyle);
		/*_style.border = "solid 4px #fff";
		_style.backgroundColor = "white";
		_style.borderRadius = "2px";#EDF1F4*/

		let _className = (layout=="vertical"?"gongqiFormVertical":"gongqiFormHorizontal");
		_className += " GongqiFormDesign";
		if(!this.props.forLookup)
		{
			_style.backgroundColor='#EEEFF1';_style.borderRadius='2px';//_style.padding = "5px";
		}

		let propFormName = this.props.formName;
		let formNameChanged = propFormName?propFormName.replace(/\./g,"_"):"";
		if((window.isPopUp && !this.props.forLookup) || (this.props.isPop && this.props.forLookup))
		{
			let outterStyle = {alignSelf:"center",border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:"2px",backgroundColor:'white'};
			let height = this.props.control.getProperty_Height();
			if(height)
			{
				if((height+"").indexOf("%") != -1)
				{
					outterStyle.height = height;
				}
				else
				{
					outterStyle.height = height+"px";
				}
			}
			let _dataSetViewBtnsStyle = {display: 'flex',justifyContent: 'flex-end',alignItems: 'center'};
			if(window.parent.window.formOSdsScrip){
				_dataSetViewBtnsStyle.display='none'
			}
			//TODO 暂时去掉 存在内容超出弹出框问题
			// _style.height=_style.height?_style.height:'100%';
			if(this.getIsUniversalViewRep()){
				let reprot_vis = this.getIsUniversalViewRep()?'block':'none';
				outterStyle.left = '3%';
				if(window.parent.window.formOSopenDataSetView){
		
					return	(<div ref={node=>this.outterDiv=node}  id={formNameChanged} style={outterStyle}>
						<div className="modal-header" ref={node=>this.modalHeader=node} style={{position:"relative"}}>
						  <div className="modal-close" onClick={this.closePopUpFormHandler.bind(this)}></div>
						  <h5 className="modal-title">{this.props.formLabel}</h5>
						</div>
						{innerToolBar}
						<div className={_className} ref={node => this.containerComponent = node} style={_style}>
							 {list}
						</div>
						<div style={{display: 'flex',justifyContent: 'flex-end',alignItems: 'center'}} id="osDataViewBtns">
							<button className='btn btn-info ufs-cancel' style={{height:'28px',margin:'3px 10px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',color: 'rgb(49, 49, 49)'}} id="universalViewRemoveSelect" onClick={this.universalViewRSelectBtn.bind(this)} ref={node=>this.universalView_RSelect=node}>移除筛选</button>
						</div>
					  </div>);
				}else if(window.parent.window.dataSetPreviewForPrintApp){
					outterStyle.top = '6%';
					return	(<div ref={node=>this.outterDiv=node}  id={formNameChanged} style={outterStyle}>
						<div className="modal-header" ref={node=>this.modalHeader=node} style={{position:"relative"}}>
						  <div className="modal-close" onClick={this.closePopUpFormHandler.bind(this)}></div>
						  <h5 className="modal-title">{this.props.formLabel}</h5>
						</div>
						{innerToolBar}
						<div className={_className} ref={node => this.containerComponent = node} style={_style}>
							 {list}
						</div>
						<div style={{display: 'flex',justifyContent: 'flex-end',alignItems: 'center'}} id="osDataViewBtns">
							<button className='btn btn-info ufs-cancel' style={{height:'28px',margin:'3px 10px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',color: 'rgb(49, 49, 49)'}} id="universalViewRemoveSelect" onClick={this.universalViewRSelectBtn.bind(this)} ref={node=>this.universalView_RSelect=node}>移除筛选</button>
							<button className='btn btn-info ufs-require' style={{height:'28px',margin:'3px 10px',width:'120px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color: 'white'}} id="universalViewPrintAppBtn" onClick={this.universalViewPrintAppBtnOk.bind(this)} ref={node=>this.universalView_PrintApp=node}>确定</button>
						</div>
					  </div>);
				}else{
				
				return	(<div ref={node=>this.outterDiv=node}  id={formNameChanged} style={outterStyle}>
					<div className="modal-header" ref={node=>this.modalHeader=node} style={{position:"relative"}}>
					  <div className="modal-close" onClick={this.closePopUpFormHandler.bind(this)}></div>
					  <h5 className="modal-title">{this.props.formLabel}</h5>
					</div>
					{innerToolBar}
					<div className={_className} ref={node => this.containerComponent = node} style={_style}>
						 {list}
					</div>
					<div style={_dataSetViewBtnsStyle}>
					<button className='btn btn-info ufs-cancel' style={{height:'28px',margin:'3px 10px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',color: 'rgb(49, 49, 49)'}} id="universalViewRemoveSelect" onClick={this.universalViewRSelectBtn.bind(this)} ref={node=>this.universalView_RSelect=node}>移除筛选</button>
					<button className='btn btn-info ufs-cancel' style={{height:'28px',margin:'3px 10px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',color: 'rgb(49, 49, 49)'}} id="universalViewPivot" onClick={this.universalViewPivotBtn.bind(this)} ref={node=>this.universalView_Pivot=node}>数据分析</button>
					<button className='btn btn-info ufs-cancel' style={{height:'28px',margin:'3px 10px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',color: 'rgb(49, 49, 49)'}} id="universalViewReport" onClick={this.universalViewReportBtn.bind(this)} ref={node=>this.universalView_Report=node}>导出</button>
					<button className='btn btn-info ufs-require' style={{height:'28px',margin:'3px 10px',width:'120px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color: 'white'}} id="universalViewDSExp" onClick={this.universalViewDSExpBtn.bind(this)} ref={node=>this.universalView_DSExp=node}>生成DS文件</button>
					</div>
				  </div>);

				}


			}else
			
				
			return	(<div ref={node=>this.outterDiv=node}  id={formNameChanged} style={outterStyle}>
		              <div className="modal-header" ref={node=>this.modalHeader=node} style={{position:"relative"}}>
						<div className="modal-close" onClick={this.closePopUpFormHandler.bind(this)}></div>
		                <h5 className="modal-title">{this.props.formLabel}</h5>
		              </div>
					  {innerToolBar}
		              <div className={_className} ref={node => this.containerComponent = node} style={_style}>
		               	{list}
		              </div>
		            </div>);
		}
		else
		{
			if(innerToolBar)
			{
				return (
					<div id={formNameChanged} style={{display:'flex',flexDirection:'column',width:'100%',height:'100%'}}>
						{innerToolBar}
						<div className={_className} ref={node => this.containerComponent = node} style={_style}>{list}</div>
					</div>
				);
			}
			else
			{
				return (<div className={_className} id={formNameChanged} ref={node => this.containerComponent = node} style={_style}>{list}</div>);
			}
			
		}
		
	}
};

FormItemDesign.defaultProps = {
};

export default FormItemDesign;



// WEBPACK FOOTER //
// ./src/formItem/FormItemDesign.js